export const PAYMENT_METHODS = ['paypal', 'crypto', 'card', 'other'];

export const PAYMENT_ICONS = { paypal: 'bi-wallet2', crypto: 'bi-coin', card: 'bi-credit-card', other: 'bi-three-dots' };

export const PAYMENT_COLORS = { paypal: '#3b82f6', crypto: '#f59e0b', card: '#10b981', other: '#a78bfa' };
